import { simboloMoneda } from '../logica/dinero';
import { Campo } from './Campo';

/**
 * Campo de importe (Pagos): se escribe como en una calculadora española («12», «12,50», «1.284,50») y la etiqueta lleva
 * la moneda del negocio («Importe (€)»). Solo comprueba el formato; el máximo (lo que queda por devolver, por ejemplo) lo
 * da la API y lo valida la API.
 */
export function CampoImporte({ etiqueta, valor, onChange, moneda, error, ayuda, bloqueado = false, nombre }: { etiqueta: string; valor: string; onChange: (v: string) => void; moneda: string; error?: string | null; ayuda?: string | null; bloqueado?: boolean; nombre?: string }) {
    return <Campo etiqueta={`${etiqueta} (${simboloMoneda(moneda)})`} tipo="number" modo="decimal" valor={valor} onChange={onChange} error={error} ayuda={ayuda} bloqueado={bloqueado} nombre={nombre} />;
}

